export enum VerificationMethod {
    SMS = 'sms',
    EMAIL = 'email',
    INVALID = 'invalid',
}
